/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useState, useEffect, useRef } from "react";
import { getPlanDuration, getPlanPrice, setMaxHeightForRefs } from "../../layout-utils";
import { Attribute } from "../../attribute";
import { SubscribeButton } from "../../atoms/subscribe-button";
import "./minimalist.m.css";

export const SubscriptionBlock = ({
  plans,
  subscriptionConfig = {},
  sso = {},
  member,
  defaultSubscriptionHandler,
  localizedTime,
  mode,
  sketchesHost,
  config
}) => {
  const { showOfferPrice = false, buttonColor = "#498966", darkButtonColor = "#498966" } = subscriptionConfig;
  const updatedButtonColor = mode === "dark" ? darkButtonColor : buttonColor;
  const [currentPlan, setCurrentPlan] = useState(plans[0]);
  const planRefs = plans.map(() => useRef(null));
  let updateGrid = plans.length < 3 ? { gridTemplateColumns: `repeat(${plans.length}, minmax(216px, 274px))` } : {};
  useEffect(() => {
    setMaxHeightForRefs(planRefs);
  }, [planRefs]);

  return (
    <div>
      <div styleName="subscription-wrapper" style={updateGrid}>
        {plans.map((plan, index) => {
          const { title, price_currency: priceCurrency, price_cents: priceCents, id } = plan;
          const updatedBorderColor = currentPlan === plan ? { borderColor: updatedButtonColor } : {};
          return (
            <div styleName="plan" key={`plan-${id}`} style={updatedBorderColor} onClick={() => setCurrentPlan(plan)}>
              <div styleName="tag-wrapper">
                <Attribute data={plan} attributeName="Tag" />
              </div>
              <label styleName="radio-container">
                <input type="radio" checked={currentPlan === plan ? "checked" : ""} name="radio" />
                <span styleName="checkmark" style={{ color: updatedButtonColor }}></span>
                <div>
                  <div styleName="title" data-test-id="plan-name" ref={planRefs[index]}>
                    {title}
                  </div>
                  <div styleName="price-wrapper" data-test-id="amount">
                    <span>{getPlanPrice(priceCurrency, priceCents)}</span>
                    <span styleName="duration-wrapper" data-test-id="duration">
                      {getPlanDuration(localizedTime, plan)}
                    </span>
                    {showOfferPrice && (
                      <div styleName="attribute-wrapper">
                        <Attribute data={plan} attributeName="Actual Price" />
                        <Attribute data={plan} attributeName="Discount" />
                      </div>
                    )}
                  </div>
                </div>
              </label>
            </div>
          );
        })}
      </div>
      <SubscribeButton
        sso={sso}
        member={member}
        defaultSubscriptionHandler={defaultSubscriptionHandler}
        subscriptionConfig={subscriptionConfig}
        plan={currentPlan}
        mode={mode}
        separator={false}
        sketchesHost={sketchesHost}
        config={config}
      />
    </div>
  );
};
